import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { MenuItem, Typography } from '@mui/material';
import standardSearch from '../functions/standardSearch';

// search keys and label shared with the Company Profile page search
const SEARCH_COLS = ['mastercompanyname', 'mastercompanyid', 'primaryccrm'];
const getLabel = (option) => option ? `${option.mastercompanyname} - ${option.mastercompanyid}` : '';

// fuzzy search over name/id, same behavior as Search Company by on the Company Profile page
const filterOptions = (options, { inputValue }) => {
    const query = inputValue.trim();
    return query === '' ? options : standardSearch(options, SEARCH_COLS, query);
};

// searchable dropdown of rebates (master companies) displayed as "name - id"
export const MIN_SEARCH_CHARS = 1;

const ModalRebateSearch = ({ tag, value, setValue, list, width = '100%', loading = false, onSearchChange }) => {
    // keep the selected option in the list so it stays valid while the list is refreshed
    const options = value && !list.some(o => String(o.mastercompanyid) === String(value.mastercompanyid)) ? [value, ...list] : list;
    return (
        <div className='d-flex flex-column align-items-start w-100'>
            <Typography>{tag}</Typography>
            <FormControl fullWidth size='small' sx={{ width }}>
                <AutoComplete
                    options={options}
                    noOptionsText={loading ? 'Searching...' : 'No matching Rebate ID or Rebate Name found'}
                    onInputChange={(e, input, reason) => reason === 'input' && onSearchChange && onSearchChange(input)}
                    size='small'
                    value={value}
                    loading={loading}
                    title={tag}
                    filterOptions={filterOptions}
                    getOptionLabel={getLabel}
                    isOptionEqualToValue={(option, selected) => String(option.mastercompanyid) === String(selected.mastercompanyid)}
                    renderInput={(params) => <TextField {...params} placeholder='Type Rebate ID or Rebate Name to search' />}
                    renderOption={(props, option) => (
                        <MenuItem
                            {...props}
                            key={option.mastercompanyid}
                            sx={{ whiteSpace: 'collapse', borderBottom: '1px solid #E6EDF1', fontSize: '14px' }}
                        >
                            {getLabel(option)}
                        </MenuItem>
                    )}
                    onChange={(e, selected) => setValue(selected)}
                />
            </FormControl>
        </div>
    );
};

export default ModalRebateSearch;
